export const TAKEOVER_CLASSNAME = "thena-iframe-takeover";
export const INFO_MSG_CLASSNAME = "thena-iframe-info-msg";
